import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { buildIconStylesheet } from "./ElementIconStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";
library.add(fab, fas, far);

const ElementIcon = (props) => {
  let element = props.element;
  const classes = style.classes(element, props.builder, props.device);
  const stylesheet = buildIconStylesheet(
    props.builder,
    props.device,
    props.cta,
    element
  );

  const iconName = () => {
    let selectedIcon = element.options["fa-icon"];

    return selectedIcon
      .replace("fas ", "")
      .replace("fab ", "")
      .replace("far ", "");
  };

  const iconPrefix = () => {
    let selectedIcon = element.options["fa-icon"];

    return selectedIcon.replace(` ${iconName()}`, "");
  };

  return (
    <React.Fragment>
      <div className={classes}>
        {element.options["icon-link"] && props.builder !== true ? (
          <a
            href={
              element.options["icon-link"].indexOf("http") > -1
                ? element.options["icon-link"]
                : `http://${element.options["icon-link"]}`
            }
            target={element.options["icon-link-new-tab"] ? "_blank" : "_self"}
            rel={element.options["icon-link-new-tab"] ? "noopener noreferrer" : undefined}
          >
            <FontAwesomeIcon icon={[iconPrefix(), iconName()]} />
          </a>
        ) : (
          <FontAwesomeIcon icon={[iconPrefix(), iconName()]} />
        )}
        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:icon`}
          stylesheet={stylesheet}
        />
      </div>
    </React.Fragment>
  );
};

const style = {
  classes: (element, builder, device) => {
    let options = element.options;
    let classes = "element-content cf-icon-element ";

    let alignmentClass = "cf-outer-center";

    if (options["cf-alignment"]) {
      if (options["cf-alignment"].indexOf("left") > -1) {
        alignmentClass = "cf-outer-left";
      } else if (options["cf-alignment"].indexOf("center") > -1) {
        alignmentClass = "cf-outer-center";
      } else if (options["cf-alignment"].indexOf("right") > -1) {
        alignmentClass = "cf-outer-right";
      }
    }

    classes += " " + alignmentClass;

    return classes;
  },
};

export default ElementIcon;
